export enum TrainingType {
  bcmea = "bcmeaTrainings",
  industry = "industryTrainings",
}

export enum TrainingTypeTitle {
  bcmea = "BCMEA Training",
  industry = "Industry Training",
}

export const BCMEATrainingTypeCols = ['Program Description', 'Period', 'Training Type', 'Status'];

export const IndustryTrainingTypeCols = ['Program Description', 'Site', 'Status', 'Expiry Date'];

export const DisclaimerText = [
  'Accepted - Employee has accepted',
  'Approved - Approved by BCMEA',
  'Candidate - Not yet approved by BCMEA',
  'Denied - Was denied by BCMEA',
  'Expired - Application for training program has expired',
  'Fail - Failed at least one phase',
  'Pass - Passed all requirements',
  'Quit - Quit after accepting',
  'Refused - Refused the program',
  'Training - Currently in training',
  'Withdrew - Withdrew before approved'
]